// Feature: business-coverage-from-quote
// Reducer for the generate-from-quote dialog. Drives the dialog stage from the
// thunk lifecycle and retains the last successful response so the ResultStep
// can render coverage numbers, the schema-match warning, and usage.

import { createSlice } from "@reduxjs/toolkit";
import {
  defaultCoverageFromQuoteState,
  ICoverageFromQuoteState,
} from "./coverageFromQuote.types";
import {
  generateCoverageFromQuoteAsync,
  resetCoverageFromQuote,
  setCoverageFromQuoteSource,
} from "./coverageFromQuoteActions";

const coverageFromQuoteSlice = createSlice({
  name: "coverageFromQuote",
  initialState: defaultCoverageFromQuoteState as ICoverageFromQuoteState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setCoverageFromQuoteSource, (state, action) => {
      state.source = action.payload;
    });
    builder.addCase(resetCoverageFromQuote, () => ({
      ...defaultCoverageFromQuoteState,
    }));
    builder.addCase(generateCoverageFromQuoteAsync.pending, (state) => {
      state.stage = "running";
      state.error = null;
    });
    builder.addCase(
      generateCoverageFromQuoteAsync.fulfilled,
      (state, action) => {
        state.stage = "done";
        state.result = action.payload;
        state.error = null;
      }
    );
    builder.addCase(
      generateCoverageFromQuoteAsync.rejected,
      (state, action) => {
        state.stage = "error";
        state.error =
          action.payload?.message || "Failed to generate coverage summary.";
      }
    );
  },
});

export const coverageFromQuoteReducer = coverageFromQuoteSlice.reducer;
